export default class Notification extends Core.Component {
  get type() {
    return this.el.getAttribute('role') === 'alert' ? 'error' : 'success';
  }

  set type(type) {
    this.el.setAttribute('role', type === 'error' ? 'alert' : 'status');
  }

  get content() {
    return this.el.innerHTML;
  }

  set content(content) {
    this.el.innerHTML = content;
  }

  get hidden() {
    return this.el.hasAttribute('hidden');
  }

  set hidden(hidden) {
    if (hidden) {
      this.el.setAttribute('hidden', '');
    } else {
      this.el.removeAttribute('hidden');
    }
  }
}
